import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  unassignedRouteTitle: {
    id: 'routes.unassignedRouteTitle',
    description: 'Unassigned Route table title',
    defaultMessage: 'Unassigned Routes',
  },
})
